import 'popper.js'
import 'bootstrap'
import 'owl.carousel';
import '@fancyapps/fancybox'

$('.owl-carousel').owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    navText: [$('.owl__nav--left'), $('.owl__nav--right')],
    navContainer: '.owl__custom-nav',
    responsive:{
        0: {
            items:1,
        },
        540: {
            items:2,
        },
        992: {
            items:3,
        }
    }
});


$(document).on('click', '.burger', function(e) {
    e.preventDefault()
    $('.mobile').addClass('is-open')
})

$(document).on('click', '.mobile__close', function(e) {
    e.preventDefault()
    $('.mobile').removeClass('is-open')
})

$(document).on('click', '.subnavigation__title', function(e) {
    e.preventDefault()
    $('.subnavigation__list').toggleClass('d-none')
})